/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const EditAlt = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M7.19296 14.5231L15.7767 5.93934C16.3625 5.35355 17.3122 5.35355 17.898 5.93934L18.6051 6.64645C19.1909 7.23223 19.1909 8.18198 18.6051 8.76777L10.0175 17.3554C9.81287 16.682 9.52931 16.0941 9.07592 15.6125C8.59359 15.1 7.97146 14.7615 7.19296 14.5231ZM6.12582 15.7983L5.45077 19.0937L8.74314 18.4193C8.54475 17.5186 8.3192 16.997 7.98369 16.6406C7.6526 16.2888 7.128 16.0091 6.12582 15.7983ZM4.70993 15.2356C4.76889 14.9478 4.91104 14.6837 5.11876 14.476L14.716 4.87868C15.8876 3.70711 17.7871 3.70711 18.9587 4.87868L19.6658 5.58579C20.8374 6.75736 20.8374 8.65685 19.6658 9.82843L10.0685 19.4257C9.86079 19.6334 9.59665 19.7756 9.30886 19.8345L4.26738 20.8673C3.91589 20.9393 3.60521 20.6286 3.67721 20.2771L4.70993 15.2356Z"
                        fill={color}
                    />
                </svg>
        );
    };
